import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./InputBox.module.css";

export default function InputBox({
  placeholder,
  setValue,
  value,
  label,
  disabled,
  validationMessage,
  notRequired = false,
  type = "text",
  onBlur,
}) {
  const [showDiv, setShowDiv] = useState(false);

  const handleBlur = (e) => {
    if (!validationMessage) {
      if (!notRequired && !value.trim()) {
        setShowDiv(true);
      } else {
        setShowDiv(false);
      }
    }

    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.input}>
          <p>{label}</p>
          <input
            type={type}
            placeholder={placeholder}
            onChange={setValue}
            onBlur={handleBlur}
            value={value}
            disabled={disabled}
            style={{
              borderColor: showDiv || validationMessage ? "red" : "lightgrey",
              background: disabled ? "#E8E8E8" : "",
            }}
          ></input>
          {showDiv && !validationMessage && validationMessage != "" && (
            <div className={styles.alert}>
              {placeholder.toLowerCase().includes("enter")
                ? `Please ${placeholder.toLowerCase()}.`
                : `Please enter ${placeholder.toLowerCase()}.`}
            </div>
          )}
          {validationMessage && (
            <div
              style={{ paddingBottom: "20px", paddingTop: "0px" }}
              className={styles.alert}
            >
              {validationMessage}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

InputBox.propTypes = {
  placeHolder: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  onBlur: PropTypes.func,
};
